module.exports = __webpack_public_path__ + "img/cost-icon__gimnasio.fc4fadd5.svg";